exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@-webkit-keyframes spin---3e23d {\n  from {\n    -webkit-transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes spin---3e23d {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.loadingIcon---z4lLP {\n  height: 132px;\n  width: 132px; }\n\n.loader---2OSoq {\n  border-width: 6px;\n  border-style: solid;\n  border-color: #3498db transparent transparent;\n  -o-border-image: none;\n     border-image: none;\n  -o-border-image: initial;\n     border-image: initial;\n  border-radius: 50%;\n  width: 100%;\n  height: 100%; }\n\n.loaderSpeed---UPTKZ {\n  -webkit-animation: spin---3e23d 1.5s linear infinite;\n          animation: spin---3e23d 1.5s linear infinite; }\n", ""]);

// exports
exports.locals = {
	"loadingIcon": "loadingIcon---z4lLP",
	"loader": "loader---2OSoq",
	"loaderSpeed": "loaderSpeed---UPTKZ",
	"spin": "spin---3e23d"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/spinner/index.scss
// module id = 1184
// module chunks = 3